"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _OwnedLicenseCreate = _interopRequireDefault(require("./OwnedLicenseCreate"));
var _OwnedLicenseDelete = _interopRequireDefault(require("./OwnedLicenseDelete"));
var _OwnedLicenseExpire = _interopRequireDefault(require("./OwnedLicenseExpire"));
var _OwnedLicenseRenew = _interopRequireDefault(require("./OwnedLicenseRenew"));
var _OwnedLicenseAssign = _interopRequireDefault(require("./OwnedLicenseAssign"));
var _HeldLicenseCreate = _interopRequireDefault(require("./HeldLicenseCreate"));
var _HeldLicenseModify = _interopRequireDefault(require("./HeldLicenseModify"));
var _HeldLicenseDelete = _interopRequireDefault(require("./HeldLicenseDelete"));
var _HeldLicenseTransfer = _interopRequireDefault(require("./HeldLicenseTransfer"));
var _VoucherCreate = _interopRequireDefault(require("./VoucherCreate"));
var _VoucherRedeem = _interopRequireDefault(require("./VoucherRedeem"));
var _VoucherDelete = _interopRequireDefault(require("./VoucherDelete"));
var _VoucherModify = _interopRequireDefault(require("./VoucherModify"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = {
  OwnedLicenseCreate: _OwnedLicenseCreate["default"],
  OwnedLicenseDelete: _OwnedLicenseDelete["default"],
  OwnedLicenseExpire: _OwnedLicenseExpire["default"],
  OwnedLicenseRenew: _OwnedLicenseRenew["default"],
  OwnedLicenseAssign: _OwnedLicenseAssign["default"],
  HeldLicenseCreate: _HeldLicenseCreate["default"],
  HeldLicenseModify: _HeldLicenseModify["default"],
  HeldLicenseDelete: _HeldLicenseDelete["default"],
  HeldLicenseTransfer: _HeldLicenseTransfer["default"],
  VoucherCreate: _VoucherCreate["default"],
  VoucherRedeem: _VoucherRedeem["default"],
  VoucherDelete: _VoucherDelete["default"],
  VoucherModify: _VoucherModify["default"]
};